import { NgModule } from '@angular/core';

import { AllowedRolesDirective } from '@directives/allowed-roles.directive';

@NgModule({
  declarations: [AllowedRolesDirective, ],
  exports: [AllowedRolesDirective, ],
})
export class DirectivesModule { }
